<template>
  <div class="pageBody">
    <div class="ohead">
      <el-input
        placeholder="请输入客户订单号"
        v-model="form.tradeno"
      ></el-input>
      <span>退款时间：</span>
      <el-date-picker
        v-model="val"
        type="datetimerange"
        range-separator="至"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>

      <el-button type="primary" @click="getData">查 询</el-button>
    </div>
    <div class="buttongroup">
      <el-button type="success" @click="handleExportExcel">导出清单</el-button>
    </div>
    <div
      style="color: red; font-size: 12px; text-align: right; margin-left: auto"
    >
      推荐一次导出七天数据，否则可能因数据量过大导出失败
    </div>
    <div class="BodyRow">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="orderId" label="交易号"> </el-table-column>
        <el-table-column prop="ordno" label="客户订单号">
          <template slot-scope="scope">
            <div>
              <p v-for="item in scope.row.ordno" :key="item">{{ item }}</p>
            </div>
          </template>
        </el-table-column>
        <!-- 客户名称/ID -->
        <el-table-column label="客户ID" width="190px">
          <template slot-scope="scope">
            <div>
              {{ scope.row.user_id }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="refundKin" label="退款金额（CNY）">
        </el-table-column>
        <el-table-column prop="gmtApply" label="退款时间"> </el-table-column>

        <el-table-column prop="y_name" label="业务员"> </el-table-column>
        <el-table-column prop="department_name" label="业务部门">
        </el-table-column>
        <el-table-column prop="g_name" label="采购员"> </el-table-column>
      </el-table>
    </div>
    <div class="allpag">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="form.pagesize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getCurrentDayBefo } from "@/utlis/date";
import { payState, formatDateCommon } from "@/utlis/orderData";
export default {
  data() {
    return {
      formatDateCommon: formatDateCommon,
      currentPage4: 1,
      total: 0,
      pageSize: 10,
      department: [],
      options: payState,
      val: "",
      form: {
        beginDatetime: null, //开始时间
        endDatetime: null, //结束时间
        tradeno: "", //交易号
        page: 1,
        pagesize: 10,
        // userInfo: "", //客户名或者用户ID
        // y_name: "", //业务员名字
        // gDepartment: "", //采购部门
      },
      tableData: [],
    };
  },
  created() {
    this.val = [
      `${getCurrentDayBefo()} 00:00:00`,
      `${getCurrentDayBefo()} 23:59:59`,
    ];
    this.form.beginDatetime = `${getCurrentDayBefo()} 00:00:00`;
    this.form.endDatetime = `${getCurrentDayBefo()} 23:59:59`;
    this.getData();
  },
  watch: {
    val() {
      if (!this.val) {
        this.form.beginDatetime = null;
        this.form.endDatetime = null;
        return false;
      }
      this.form.beginDatetime = this.val[0];
      this.form.endDatetime = this.val[1];
    },
  },
  computed: {},
  methods: {
    //   导出表格
    async handleExportExcel() {
      var tabledata = [];
      var form = JSON.parse(JSON.stringify(this.form));
      form.page = 1;
      // form.pagesize = Number(this.total) + 50;
      form.pagesize = 99999999999999;
      console.log(form);
      await this.$api.financialApi
        .alibabaRefund(form)
        .then((res) => {
          console.log(res);
          tabledata = res.data.list;
        })
        .catch((err) => {
          this.$message.warning("错误");
          return false;
        });
      if (!this.tableData) {
        this.$message.warning("暂无数据");
        return false;
      }

      require.ensure([], () => {
        const { export_json_to_excel } = require("@/utlis/Export2Excel");
        const tHeader = [
          "交易号",
          "客户订单号",
          "客户ID",
          "退款金额（CNY）",
          "退款时间",
          "业务员",
          "业务部门",
          "采购员",
        ];
        const filterVal = [
          "orderId",
          "ordno",
          "user_id",
          "refundKin",
          "gmtApply",
          "y_name",
          "department_name",
          "g_name",
        ];
        const list = tabledata; //把data里的tableData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "1688退款订单列表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getData() {
      this.$api.financialApi
        .alibabaRefund(this.form)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.list;
          this.total = Number(res.data.total);
          this.department = res.department;
        })
        .catch((err) => {
          this.tableData = [];
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.pagesize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getData();
    },
  },
};
</script>
<style scoped lang="scss">
.ohead {
  display: flex;
  align-items: center;

  * {
    margin-right: 15px;
  }

  .el-input {
    width: 220px;
  }
}

.buttongroup {
  margin: 20px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  span {
    margin-right: 150px;
    font-size: 20px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>
